import CompletedJobsIcon from '@mui/icons-material/FlightTakeoffOutlined';
import ActiveJobsIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import { useMemo } from 'react';

import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { isNonNullish } from 'infrastructure/utils/isNonNullish';
import { NavigationItem, NavigationLink } from 'targets/web/components/Navigation';
import { jobsRoutes } from 'targets/customer-portal/modules/jobs/navigation/routes';

interface AccessLimitedNavigationLink extends NavigationLink {
  requireFeatureConfig?: string;
}

type AccessLimitedNavigationItem = Omit<NavigationItem, 'nested'> & {
  nested?: AccessLimitedNavigationLink[];
};

export const useAvailableNavigationLinks = (): AccessLimitedNavigationItem[] => {
  const t = useTranslationPrefix('customer_portal.navigation');

  return useMemo(() => {
    return [
      {
        url: `${jobsRoutes.jobs}/${jobsRoutes.internalRoutes.active}`,
        icon: <ActiveJobsIcon />,
        label: t('active_jobs'),
      },
      {
        url: `${jobsRoutes.jobs}/${jobsRoutes.internalRoutes.completed}`,
        icon: <CompletedJobsIcon />,
        label: t('completed_jobs'),
      },
    ].filter(isNonNullish);
  }, [t]);
};
